import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, } from "react-router-dom";
import './Menu.css';
import { useInView } from 'react-intersection-observer';
import CategoryTabs, { CategoryTab } from './CategoryTabs';
import { getMenu, Category, MenuItem } from '../../services/api';

interface CategoryProps {
  categories: Category[];
}

const Menu: React.FC<CategoryProps> = ({ categories }) => {
  let { category } = useParams();

  let navigate = useNavigate();
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<Category>();
  if (!category) {
    category = "all";
  }

  const { ref: firstSectionRef, inView: firstSectionInView } = useInView({ triggerOnce: true });
  const handleCategoryClick = (selection: string) => {
    navigate(`/our-menus/${selection}`)
  }

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await getMenu(category as string);
        setMenu(data.menus_list);
        setSelectedCategory(data.selected_category);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };

    fetchMenu();
  }, [category]);

  const categ: CategoryTab[] = [
    { label: "All", slug: "all" },
    { label: "Season Menu", slug: "season-menu" },
    { label: "Salad", slug: "salad" },
    { label: "Bowl", slug: "bowl" },
    { label: "Sandwich", slug: "sandwich" },
    { label: "Soup&Side", slug: "soup" },
    { label: "DRINK", slug: "drink" },
  ];

  return (
    <>
      <div className='min-h-[100vh] font'>
        <div className="w-full mt-[73px]">
          <img src='https://livfarm-hompage-v2.s3.ap-northeast-2.amazonaws.com/menu/banner/banner393_150.jpg' alt='Img not found' width={'100%'} className='block md:hidden' />
          <img src='https://livfarm-hompage-v2.s3.ap-northeast-2.amazonaws.com/menu/banner/banner1920_500.jpg' alt='Img not found' width={'100%'} className='hidden md:block' />
        </div>

        <section className='hidden lg:block'>
          <div className='mt-32 container lg:pl-24 lg:pr-24 pl-2 pr-2'>
            <CategoryTabs
              categories={categ}
              activeSlug={category}
              onSelect={handleCategoryClick}
            />
          </div>
        </section>

        <section ref={firstSectionRef} className={`text-livos-green container transition-all duration-500 ${firstSectionInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{ marginTop: 100 }}>
          <div className='text-center gap gap-4 pl-12 pr-12 md:pl-24 md:pr-24'>
            <h3 className='md:text-[50px] text-[30px] font-crimson font-bold'>{selectedCategory?.name}</h3>
            {
              selectedCategory && <p className='md:text-[24px] text-[12px] font-pretendard font-medium mt-[30px]'>{selectedCategory?.description}</p>
            }
          </div>
        </section>

        <section className='container md:pl-24 md:pr-24 pl-12 pr-12 mb-[150px] mt-[50px]'>
          {menu.length > 0 && (
            <div className='flex justify-center mt-18 md:mt-32'>
              <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-y-[100px]'>
                {menu.map((item) => (
                  <div className="pl-4 pr-4 max-w-sm bg-white rounded-lg">
                    <p>
                      <img className="rounded-t-lg" src={item.image} alt='Img not found' />
                    </p>
                    <div className=" text-center text-livos-green">
                      <p className='mt-[40px]'>
                        <h5 className="mb-2 text-[22px] font-pretendard font-bold tracking-tight">{item.title}</h5>
                      </p>
                      <p className="mb-3 font-medium font-pretendard font-[12px] opacity-60">{item.sub_title}</p>
                      <p className="mb-3 text-[14px] font-crimson font-semibold min-h-[60px]">
                        {item.description.split('\\n').map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            {index < item.description.split('\\n').length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                      <div className='grid grid-cols-4 pt-4 divide-x divide-livos-light font-medium text-livos-medium_light bottom-0 font-crimson font-semibold text-[13px]'>
                        <div className='grid grid-cols-1'>
                          <div>
                            <p>{item.kcal}</p>
                            <p>kcal</p>
                          </div>
                        </div>
                        <div className='grid grid-cols-1'>
                          <div>
                            <p>{item.carbs}g</p>
                            <p>Carbs</p>
                          </div>
                        </div>
                        <div className='grid grid-cols-1'>
                          <div>
                            <p>{item.protein}g</p>
                            <p>Protein</p>
                          </div>
                        </div>
                        <div className='grid grid-cols-1'>
                          <div>
                            <p>{item.fat}g</p>
                            <p>Fat</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default Menu;
